import { TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryTitleProps as Props } from './types';

export const WorkHistoryTitle = memo(({ className, item }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('WorkHistoryTitle', className)}
      sx={SX.root}
    >
      <TextEllipsis w="90%" variant="body4" color="grey.700" fontWeight="400">
        {item.profile_positions?.map((i) => `${i.title}`).join(' & ')}
      </TextEllipsis>
    </Styled.Wrapper>
  );
});

WorkHistoryTitle.displayName = 'WorkHistoryTitle';
